export default "__VITE_ASSET__B9gw3vGl__"